var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-overlay", { attrs: { show: _vm.is_load } }, [
    _vm.product.id > 0
      ? _c(
          "div",
          { staticClass: "categ_info" },
          [
            _c("div", {
              staticClass: "prod_ai_image mb-5 pt-5",
              on: { click: _vm.showAi },
            }),
            _vm._v(" "),
            _c("fileload", {
              attrs: { doc_id: _vm.product.id, doc_type: "product" },
              on: { on_load: _vm.on_loading_files },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }